export default "__VITE_ASSET__ac4b704a__"